<template>
  <div class="d-flex flex-column align-center justify-center">
    <about-us :icons="icon"></about-us>
    <v-row style="max-width: 1200px" class="mb-4">
      <v-col md="6">
        <v-img
          src="../assets/about-banenr.png"
        ></v-img>
      </v-col>
      <v-col md="6">
        <p class="body-1" v-for="(p, index) in content" :key="index" style="text-indent: 24px">
          {{ p }}
        </p>
      </v-col>
    </v-row>
<!--    <v-parallax-->
<!--      height="300"-->
<!--      class="mt-6 mb-10 d-flex justify-center"-->
<!--      style="width: 100%"-->
<!--      src="https://cdn.vuetifyjs.com/images/parallax/material2.jpg"-->
<!--    >-->
<!--      <v-row style="width: 1200px">-->
<!--        <v-col-->
<!--          v-for="(item, index) in points"-->
<!--          class="d-flex flex-column justify-center align-center"-->
<!--          :key="index"-->
<!--        >-->
<!--          <span class="display-2">{{item.value}}</span>-->
<!--          <v-divider light></v-divider>-->
<!--          <span class="headline">{{item.title}}</span>-->
<!--        </v-col>-->
<!--      </v-row>-->
<!--    </v-parallax>-->

<!--    <divider-title-->
<!--      title="专业团队"-->
<!--      sub-title="Teams"-->
<!--    ></divider-title>-->
<!--    <div class="d-flex justify-center align-center" style="height: 400px">-->
<!--      <v-row-->
<!--        style="max-width: 1200px; flex-shrink: 0"-->
<!--        class="d-flex justify-space-around"-->
<!--      >-->
<!--        <v-col v-for="(member, index) in team" :key="index" md="4">-->
<!--          <v-card-->
<!--            tile-->
<!--            flat-->
<!--          >-->
<!--            <v-img-->
<!--              :src="member.img"-->
<!--              height="300px"-->
<!--            >-->
<!--            </v-img>-->
<!--            <v-card-text class="d-flex justify-center subtitle-2">-->
<!--              {{ member.name }}-->
<!--            </v-card-text>-->
<!--          </v-card>-->
<!--        </v-col>-->
<!--      </v-row>-->
<!--    </div>-->
  </div>
</template>

<script>
import AboutUs from './AboutUs.vue';
import DividerTitle from './DividerTitle.vue';

export default {
  name: 'AboutUsComponent',

  // eslint-disable-next-line vue/no-unused-components
  components: { DividerTitle, AboutUs },
  props: {
    img: {
      type: String,
      default() {
        return 'http://demo.nicebox.cn/58dfa8f33644a3a4/img/upimages/pkgimg/pkgimg/1/20180328144007154.jpg';
      },
    },
    content: {
      type: Array,
      default() {
        return [
          '上海思稞科技有限公司成立于2017年，是一家专注于电子、通讯、汽车、新能源和医疗设备等行业的热管理及CAE咨询服务、产品和技术的整体解决方案提供商。致力于帮助客户创建可靠、低成本、高性能和紧凑的产品。',
        ];
      },
    },

    points: {
      type: Array,
      default() {
        return [
          {
            title: '国家专利',
            value: '200',
          },
          {
            title: '专业人员',
            value: '360',
          },
          {
            title: '研发产品',
            value: '1000',
          },
        ];
      },
    },

    icons: {
      type: Array,
      default() {
        return undefined;
      },
    },

    team: {
      type: Array,
      default() {
        return [
          {
            img: 'http://img.qqzhi.com/uploads/2018-11-29/074111761.jpg',
            name: 'Steve Jobs',
          },
          {
            img: 'https://media.13newsnow.com/assets/GANNETT/images/'
              + 'ec5462e2-bf2d-4fd0-b8be-3fd15bb8277e/ec5462e2-bf2d-4fd0-b8be-3fd15bb8277e_750x422.png',
            name: 'Tim Cook',
          },
          {
            img: 'https://bkimg.cdn.bcebos.com/pic/dc54564e9258d109c0e3babbdd58ccbf6c814db2?x-bce-'
              + 'process=image/watermark,g_7,image_d2F0ZXIvYmFpa2U4MA==,xp_5,yp_5',
            name: 'Jony Ive',
          },
        ];
      },
    },
  },
};
</script>

<style scoped>

</style>
